import gql from 'graphql-tag';

export const getShiftTurnover = gql`
  query getShiftTurnover($id: String!) {
    getShiftTurnover(id: $id) {
      id
      status
      shiftDate
      incomingCompletedDate
      departingCompletedDate
      createdAt
      version
      updatedAt
      businessUnit {
        id
        name
      }
      ShiftGroup {
        id
        name
      }
      ShiftType {
        id
        name
      }
      AOR {
        id
        name
        abbreviation
        dopGroupId
        AORSubSystems {
          id
          name
        }
      }
      ShiftDetails {
        id
        incomingDepartingFlag
        Analyst {
          id
          firstName
          lastName
        }
        fitFlag
        scadaFlag
        additionalComments
        reviewedAllSections
        ShiftTurnoverItems {
          id
          turnoverFlag
          comments
          ShiftItem {
            id
            name
            sortOrder
          }
        }
        ShiftTurnoverMitigations {
          id
          turnoverFlag
          ShiftMitigation {
            id
            name
          }
        }
      }
    }
  }
`;
